// KnowledgeBase Quasar Separator plugin
// Adds Quasar styling to horizontal rules rendered from Markdown (---)

import { registerMarkdownPostProcessor } from '../../services/PluginAPI.js'
import './styles/separator.css'

export function registerQuasarSeparatorPlugin() {
  registerMarkdownPostProcessor(
    (root) => {
      const hrs = Array.from(root.querySelectorAll('hr'))
      for (const hr of hrs) {
        try {
          // Replace <hr> with a styled div to ensure visibility in KB preview
          // Create a relative wrapper so the app's absolute-bottom separator can position correctly
          const wrapper = document.createElement('div')
          wrapper.style.margin = hr.style.margin || '1rem 0'
          wrapper.style.position = 'relative'
          wrapper.style.minHeight = '1.2rem'

          // Create the exact separator element used elsewhere so global app styles apply
          const sep = document.createElement('div')
          sep.className = 'absolute-bottom rpg-divider'
          sep.setAttribute('style', 'background: none; z-index: 10;')
          sep.textContent = '✦'

          wrapper.appendChild(sep)
          hr.parentElement.replaceChild(wrapper, hr)
        } catch (e) {
          /* noop */
        }
      }
    },
    { sortOrder: 50 }
  )
}

export default { registerQuasarSeparatorPlugin }
